import { SidebarMenuItemType } from '@ltvco/refresh-lib/v2';
import {
  AttachMoneyOutlined,
  CameraAltOutlined,
  CarRepairOutlined,
  LoyaltyOutlined,
} from '@mui/icons-material';

export const ERROR_MESSAGES = {
  TECHNICAL_DIFFICULTIES:
    'We are experiencing technical difficulties getting the vehicle history. Please check your input and try again',
  INVALID_INPUT: 'Invalid input. Please check your input and try again',
  NO_FORECAST_AVAILABLE:
    'We were unable to generate a value forecast for this vehicle. Please try with different vehicle information.',
  NO_VEHICLE_FOUND:
    'No vehicle found using the provided information. Please try with different vehicle information.',
  NO_BUDGET: 'Please enter a valid budget range.',
  INVALID_BUDGET: 'Maximum budget must be greater than minimum budget.',
} as const;

export const additionalSidebarItems: SidebarMenuItemType[] = [
  {
    key: 'photoDamageAnalyzer',
    icon: CameraAltOutlined,
    label: 'Photo Damage Analyzer',
    url: '/bumper-chat/chat/photo-damage-analyzer',
    tooltip: 'Photo Damage Analyzer',
  },
  {
    key: 'valueForecaster',
    icon: AttachMoneyOutlined,
    label: 'Value Forecaster',
    url: '/bumper-chat/chat/value-forecaster',
    tooltip: 'Value Forecaster',
  },
  {
    key: 'repairCostEstimator',
    icon: CarRepairOutlined,
    label: 'Repair Cost Estimator',
    url: '/bumper-chat/chat/repair-cost-estimator',
    tooltip: 'Repair Cost Estimator',
  },
  {
    key: 'vehicleMatchmaker',
    icon: LoyaltyOutlined,
    label: 'Vehicle Matchmaker',
    url: '/bumper-chat/vehicle-matchmaker',
    tooltip: 'Smart Vehicle Matchmaker',
  },
];
